import React, {useState} from 'react';

import {TableHeaderRow} from '@devexpress/dx-react-grid-material-ui';
import {Popper, ClickAwayListener} from '@material-ui/core';
import {MoreIcon, FixButton, useStyles} from './style'

export const TableHeaderContent = ({
                                       column,
                                       children,
                                       ...restProps
                                   }, fixColumn = null, leftColumns = [], editColumn, editable, editingColumns) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => setAnchorEl(anchorEl ? null : event.currentTarget)
    const changeColumns = (columnName) => fixColumn(columnName.name)
    const onEditValues = (columnName) => editColumn(columnName)
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    const clickAwayHandler = () => {
        setAnchorEl(null)
    }

    return (
        <>
            <TableHeaderRow.Content
                column={column}
                {...restProps}>
                {children}
                <ClickAwayListener onClickAway={clickAwayHandler}>
                    <MoreIcon onClick={handleClick} aria-describedby={id}/>
                </ClickAwayListener>
            </TableHeaderRow.Content>
            <Popper style={{zIndex: 1000}} id={id} open={open} anchorEl={anchorEl}>
                <div className={classes.paper}>
                    <FixButton variant="contained" onClick={() => changeColumns(column)}
                               color="disabled">{!leftColumns.includes(column.name) ? `Fixar coluna` : `Desfixar coluna`} </FixButton>
                    {
                        (editable && editingColumns.find(x => x.editingEnabled && (x.columnName === column.name))) &&
                        <FixButton variant="contained" onClick={() => onEditValues(column)} color="disabled"> Alterar
                            Valores </FixButton>
                    }

                </div>
            </Popper>
        </>
    )
};
